import { useLocalStorageState, useMemoizedFn } from 'ahooks'

export type GeneratorType = 'auto' | 'manual'

/**
 * 初始化生成歌词的类型，默认为手动
 * @returns 初始化生成歌词的类型
 */
export function useInitGeneratorType() {
  const [initGeneratorType, setInitGeneratorType] =
    useLocalStorageState<GeneratorType>('music-generator-type', {
      defaultValue: 'manual',
      listenStorageChange: true,
    })

  const onChangeGeneratorType = useMemoizedFn(
    (generatorType: GeneratorType) => {
      setInitGeneratorType(generatorType)
    },
  )

  return {
    initGeneratorType,
    onChangeGeneratorType,
  }
}
